import { store } from '@betacrew/jars-flux'
import { PAGE_STATE } from '../../constants/constants';
export const componentKey = "VIEW_NOTICE_SECTION";

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        setLoadingState: (state, action) => {
            state.loadingState = action.payload;
        },
        setNoticeDetail: (state, action) => {
            state.noticeDetail = action.payload;
        },
        setPayerDetails: (state, action) => {
            state.payerDetails = action.payload;
        },
        setNoticeNotes: (state, action) => {
            state.noticeNotes = action.payload;
        },
        setNoticeTasksList: (state, action) => {
            state.noticeTasksList = action.payload;
        },
        setNoticeDocumentList: (state, action) => {
            state.noticeDocumentList = action.payload;
        },
        setClientList: (state, action) => {
            state.clientList = action.payload;
        },
        setInvitedAssigneeList: (state, action) => {
            state.invitedAssigneeList = action.payload;
        },
        setAssigneeList: (state, action) => {
            state.assigneeList = action.payload;
        },
        setTaskStatusList: (state, action) => {
            state.taskStatusList = action.payload;
        },
        setEncryptedNoticeID: (state, action) => {
            state.encryptedNoticeID = action.payload;
        },
        setExportFile: (state, action) => {
            state.exportFile = action.payload;
        },
    },
    initialReducerState: {
        loadingState: { state: PAGE_STATE.PAGE_READY, message: "" },
        noticeDetail: {},
        payerDetails: null,
        noticeNotes: null,
        noticeTasksList: null,
        noticeDocumentList: null,
        clientList: null,
        invitedAssigneeList: null,
        assigneeList: [],
        taskStatusList: [],
        encryptedNoticeID: null,
        exportFile: null,
    }
});
export const { setLoadingState, setNoticeDetail, setExportFile, setPayerDetails, setNoticeNotes, setNoticeTasksList, setNoticeDocumentList, setClientList, setInvitedAssigneeList, setAssigneeList, setTaskStatusList, setEncryptedNoticeID } = actions;
